import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { Magento2 } from '../../../RestApi';
import BrowserPersistence from '../../../util/simplePersistence';
import { closeDrawer } from '../app';
import { createCart, removeCart } from '../cart';
import actions from './actions';
var request = Magento2.request;
var storage = new BrowserPersistence();
export var beginCheckout = function beginCheckout() {
  return /*#__PURE__*/function () {
    var _thunk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var storedAvailableShippingMethods, storedBillingAddress, storedPaymentMethod, storedShippingAddress, storedShippingMethod;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Before we begin, reset the state of checkout to clear out stale data.
              dispatch(actions.reset());
              _context.next = 3;
              return retrieveAvailableShippingMethods();

            case 3:
              storedAvailableShippingMethods = _context.sent;
              _context.next = 6;
              return retrieveBillingAddress();

            case 6:
              storedBillingAddress = _context.sent;
              _context.next = 9;
              return retrievePaymentMethod();

            case 9:
              storedPaymentMethod = _context.sent;
              _context.next = 12;
              return retrieveShippingAddress();

            case 12:
              storedShippingAddress = _context.sent;
              _context.next = 15;
              return retrieveShippingMethod();

            case 15:
              storedShippingMethod = _context.sent;
              dispatch(actions.begin({
                availableShippingMethods: storedAvailableShippingMethods || [],
                billingAddress: storedBillingAddress,
                paymentCode: storedPaymentMethod && storedPaymentMethod.code,
                paymentData: storedPaymentMethod && storedPaymentMethod.data,
                shippingAddress: storedShippingAddress || {},
                shippingMethod: storedShippingMethod && storedShippingMethod.carrier_code,
                shippingTitle: storedShippingMethod && storedShippingMethod.carrier_title
              }));

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function thunk(_x) {
      return _thunk.apply(this, arguments);
    }

    return thunk;
  }();
};
export var cancelCheckout = function cancelCheckout() {
  return /*#__PURE__*/function () {
    var _thunk2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(actions.reset());

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function thunk(_x2) {
      return _thunk2.apply(this, arguments);
    }

    return thunk;
  }();
};
export var resetCheckout = function resetCheckout() {
  return /*#__PURE__*/function () {
    var _thunk3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return dispatch(closeDrawer());

            case 2:
              dispatch(actions.reset());

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function thunk(_x3) {
      return _thunk3.apply(this, arguments);
    }

    return thunk;
  }();
};
export var resetReceipt = function resetReceipt() {
  return /*#__PURE__*/function () {
    var _thunk4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return dispatch(actions.receipt.reset());

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function thunk(_x4) {
      return _thunk4.apply(this, arguments);
    }

    return thunk;
  }();
};
export var submitPaymentMethodAndBillingAddress = function submitPaymentMethodAndBillingAddress(payload) {
  return /*#__PURE__*/function () {
    var _thunk5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch) {
      var countries, formValues, billingAddress, paymentMethod;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              countries = payload.countries, formValues = payload.formValues;
              billingAddress = formValues.billingAddress, paymentMethod = formValues.paymentMethod;
              return _context5.abrupt("return", Promise.all([dispatch(submitBillingAddress({
                billingAddress: billingAddress,
                countries: countries
              })), dispatch(submitPaymentMethod(paymentMethod))]));

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function thunk(_x5) {
      return _thunk5.apply(this, arguments);
    }

    return thunk;
  }();
};
export var submitBillingAddress = function submitBillingAddress(payload) {
  return /*#__PURE__*/function () {
    var _thunk6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(dispatch, getState) {
      var _getState, cart, cartId, billingAddress, countries, desiredBillingAddress;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              dispatch(actions.billingAddress.submit());
              _getState = getState(), cart = _getState.cart;
              cartId = cart.cartId;

              if (cartId) {
                _context6.next = 5;
                break;
              }

              throw new Error('Missing required information: cartId');

            case 5:
              _context6.prev = 5;
              billingAddress = payload.billingAddress, countries = payload.countries;
              desiredBillingAddress = billingAddress;

              if (!billingAddress.sameAsShippingAddress) {
                desiredBillingAddress = formatAddress(billingAddress, countries);
              }

              _context6.next = 11;
              return saveBillingAddress(desiredBillingAddress);

            case 11:
              dispatch(actions.billingAddress.accept(desiredBillingAddress));
              _context6.next = 18;
              break;

            case 14:
              _context6.prev = 14;
              _context6.t0 = _context6["catch"](5);
              dispatch(actions.billingAddress.reject(_context6.t0));
              throw _context6.t0;

            case 18:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[5, 14]]);
    }));

    function thunk(_x6, _x7) {
      return _thunk6.apply(this, arguments);
    }

    return thunk;
  }();
};
export var submitPaymentMethod = function submitPaymentMethod(payload) {
  return /*#__PURE__*/function () {
    var _thunk7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(dispatch, getState) {
      var _getState2, cart, cartId;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              dispatch(actions.paymentMethod.submit());
              _getState2 = getState(), cart = _getState2.cart;
              cartId = cart.cartId;

              if (cartId) {
                _context7.next = 5;
                break;
              }

              throw new Error('Missing required information: cartId');

            case 5:
              _context7.prev = 5;
              _context7.next = 8;
              return savePaymentMethod(payload);

            case 8:
              dispatch(actions.paymentMethod.accept(payload));
              _context7.next = 15;
              break;

            case 11:
              _context7.prev = 11;
              _context7.t0 = _context7["catch"](5);
              dispatch(actions.paymentMethod.reject(_context7.t0));
              throw _context7.t0;

            case 15:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[5, 11]]);
    }));

    function thunk(_x8, _x9) {
      return _thunk7.apply(this, arguments);
    }

    return thunk;
  }();
};
export var submitShippingAddress = function submitShippingAddress() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return /*#__PURE__*/function () {
    var _thunk8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(dispatch, getState) {
      var formValues, countries, setGuestEmail, setShippingAddressOnCart, _getState3, cart, user, cartId, address, firstname, lastname, street, city, region_code, postcode, telephone, country_id, _yield$setShippingAdd, data, shippingMethods;

      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              dispatch(actions.shippingAddress.submit());
              formValues = payload.formValues, countries = payload.countries, setGuestEmail = payload.setGuestEmail, setShippingAddressOnCart = payload.setShippingAddressOnCart;
              _getState3 = getState(), cart = _getState3.cart, user = _getState3.user;
              cartId = cart.cartId;

              if (cartId) {
                _context8.next = 6;
                break;
              }

              throw new Error('Missing required information: cartId');

            case 6:
              _context8.prev = 6;
              address = formatAddress(formValues, countries);

              if (user.isSignedIn) {
                _context8.next = 13;
                break;
              }

              if (formValues.email) {
                _context8.next = 11;
                break;
              }

              throw new Error('Missing required information: email');

            case 11:
              _context8.next = 13;
              return setGuestEmail({
                variables: {
                  cartId: cartId,
                  email: formValues.email
                }
              });

            case 13:
              firstname = address.firstname, lastname = address.lastname, street = address.street, city = address.city, region_code = address.region_code, postcode = address.postcode, telephone = address.telephone, country_id = address.country_id;
              _context8.next = 16;
              return setShippingAddressOnCart({
                variables: {
                  cartId: cartId,
                  firstname: firstname,
                  lastname: lastname,
                  street: street,
                  city: city,
                  region_code: region_code,
                  postcode: postcode,
                  telephone: telephone,
                  country_id: country_id
                }
              });

            case 16:
              _yield$setShippingAdd = _context8.sent;
              data = _yield$setShippingAdd.data;
              // We can get the shipping methods immediately after setting the
              // address. Grab it from the response and put it in the store.
              shippingMethods = data.setShippingAddressesOnCart.cart.shipping_addresses[0].available_shipping_methods; // On success, save to local storage.

              _context8.next = 21;
              return saveAvailableShippingMethods(shippingMethods);

            case 21:
              _context8.next = 23;
              return saveShippingAddress(address);

            case 23:
              dispatch(actions.getShippingMethods.receive(shippingMethods));
              dispatch(actions.shippingAddress.accept(address));
              _context8.next = 31;
              break;

            case 27:
              _context8.prev = 27;
              _context8.t0 = _context8["catch"](6);
              dispatch(actions.shippingAddress.reject(_context8.t0));
              throw _context8.t0;

            case 31:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[6, 27]]);
    }));

    function thunk(_x10, _x11) {
      return _thunk8.apply(this, arguments);
    }

    return thunk;
  }();
};
export var submitShippingMethod = function submitShippingMethod(payload) {
  return /*#__PURE__*/function () {
    var _thunk9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(dispatch, getState) {
      var _getState4, cart, cartId, desiredShippingMethod;

      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              dispatch(actions.shippingMethod.submit());
              _getState4 = getState(), cart = _getState4.cart;
              cartId = cart.cartId;

              if (cartId) {
                _context9.next = 5;
                break;
              }

              throw new Error('Missing required information: cartId');

            case 5:
              _context9.prev = 5;
              desiredShippingMethod = payload.formValues.shippingMethod;
              _context9.next = 9;
              return saveShippingMethod(desiredShippingMethod);

            case 9:
              dispatch(actions.shippingMethod.accept(desiredShippingMethod));
              _context9.next = 16;
              break;

            case 12:
              _context9.prev = 12;
              _context9.t0 = _context9["catch"](5);
              dispatch(actions.shippingMethod.reject(_context9.t0));
              throw _context9.t0;

            case 16:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[5, 12]]);
    }));

    function thunk(_x12, _x13) {
      return _thunk9.apply(this, arguments);
    }

    return thunk;
  }();
};
export var submitOrder = function submitOrder(_ref) {
  var fetchCartId = _ref.fetchCartId;
  return /*#__PURE__*/function () {
    var _thunk10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(dispatch, getState) {
      var _getState5, cart, user, cartId, billing_address, paymentMethod, shipping_address, shipping_method, guestShippingEndpoint, authedShippingEndpoint, shippingEndpoint, guestPaymentEndpoint, authedPaymentEndpoint, paymentEndpoint, response;

      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              dispatch(actions.order.submit());
              _getState5 = getState(), cart = _getState5.cart, user = _getState5.user;
              cartId = cart.cartId;

              if (cartId) {
                _context10.next = 5;
                break;
              }

              throw new Error('Missing required information: cartId');

            case 5:
              _context10.next = 7;
              return retrieveBillingAddress();

            case 7:
              billing_address = _context10.sent;
              _context10.next = 10;
              return retrievePaymentMethod();

            case 10:
              paymentMethod = _context10.sent;
              _context10.next = 13;
              return retrieveShippingAddress();

            case 13:
              shipping_address = _context10.sent;
              _context10.next = 16;
              return retrieveShippingMethod();

            case 16:
              shipping_method = _context10.sent;

              if (billing_address.sameAsShippingAddress) {
                billing_address = shipping_address;
              }

              _context10.prev = 18;
              // POST to shipping-information to submit the shipping address and shipping method.
              guestShippingEndpoint = "/rest/V1/guest-carts/".concat(cartId, "/shipping-information");
              authedShippingEndpoint = '/rest/V1/carts/mine/shipping-information';
              shippingEndpoint = user.isSignedIn ? authedShippingEndpoint : guestShippingEndpoint;
              _context10.next = 24;
              return request(shippingEndpoint, {
                method: 'POST',
                body: JSON.stringify({
                  addressInformation: {
                    billing_address: billing_address,
                    shipping_address: shipping_address,
                    shipping_carrier_code: shipping_method.carrier_code,
                    shipping_method_code: shipping_method.method_code
                  }
                })
              });

            case 24:
              // POST to payment-information to submit the payment details and billing address,
              // Note: this endpoint also actually submits the order.
              guestPaymentEndpoint = "/rest/V1/guest-carts/".concat(cartId, "/payment-information");
              authedPaymentEndpoint = '/rest/V1/carts/mine/payment-information';
              paymentEndpoint = user.isSignedIn ? authedPaymentEndpoint : guestPaymentEndpoint;
              _context10.next = 29;
              return request(paymentEndpoint, {
                method: 'POST',
                body: JSON.stringify({
                  billingAddress: billing_address,
                  cartId: cartId,
                  email: shipping_address.email,
                  paymentMethod: {
                    additional_data: {
                      payment_method_nonce: paymentMethod.data.nonce
                    },
                    method: paymentMethod.code
                  }
                })
              });

            case 29:
              response = _context10.sent;
              dispatch(actions.receipt.setOrder({
                id: response,
                shipping_address: shipping_address
              })); // Clear out everything we've saved about this cart from local
              // storage. Then remove and create a new cart.

              _context10.next = 33;
              return clearCheckoutDataFromStorage();

            case 33:
              _context10.next = 35;
              return dispatch(removeCart());

            case 35:
              _context10.prev = 35;
              dispatch(createCart({
                fetchCartId: fetchCartId
              }));
              _context10.next = 42;
              break;

            case 39:
              _context10.prev = 39;
              _context10.t0 = _context10["catch"](35);
              return _context10.abrupt("return");

            case 42:
              dispatch(actions.order.accept());
              _context10.next = 49;
              break;

            case 45:
              _context10.prev = 45;
              _context10.t1 = _context10["catch"](18);
              dispatch(actions.order.reject(_context10.t1));
              throw _context10.t1;

            case 49:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, null, [[18, 45], [35, 39]]);
    }));

    function thunk(_x14, _x15) {
      return _thunk10.apply(this, arguments);
    }

    return thunk;
  }();
};
export var createAccount = function createAccount(_ref2) {
  var history = _ref2.history;
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(dispatch, getState) {
      var _getState6, checkout, _checkout$receipt$ord, email, firstName, lastName, accountInfo;

      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _getState6 = getState(), checkout = _getState6.checkout;
              _checkout$receipt$ord = checkout.receipt.order.shipping_address, email = _checkout$receipt$ord.email, firstName = _checkout$receipt$ord.firstname, lastName = _checkout$receipt$ord.lastname;
              accountInfo = {
                email: email,
                firstName: firstName,
                lastName: lastName
              }; // Once we grab what we need from checkout state we can reset.

              _context11.next = 5;
              return dispatch(resetCheckout());

            case 5:
              history.push("/create-account?".concat(new URLSearchParams(accountInfo)));

            case 6:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    return function (_x16, _x17) {
      return _ref3.apply(this, arguments);
    };
  }();
};
/* helpers */

/**
 * Formats an address in the shape the REST API expects.
 * TODO: Can we remove this code once address submissions switch to GraphQL?
 *
 * This function may throw.
 *
 * @param {object} address - The input address.
 * @param {object[]} countries - The list of countries data.
 */

export var formatAddress = function formatAddress() {
  var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var countries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var region_code = address.region_code;
  var countryCode = DEFAULT_COUNTRY_CODE;
  var country = countries.find(function (_ref4) {
    var id = _ref4.id;
    return id === countryCode;
  });
  var regions = country.available_regions;
  var region = regions.find(function (_ref5) {
    var code = _ref5.code;
    return code === region_code;
  });
  return _objectSpread({
    country_id: countryCode,
    region_id: region.id,
    region_code: region.code,
    region: region.name
  }, address);
};

function clearAvailableShippingMethods() {
  return _clearAvailableShippingMethods.apply(this, arguments);
}

function _clearAvailableShippingMethods() {
  _clearAvailableShippingMethods = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            return _context13.abrupt("return", storage.removeItem('availableShippingMethods'));

          case 1:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _clearAvailableShippingMethods.apply(this, arguments);
}

function retrieveAvailableShippingMethods() {
  return _retrieveAvailableShippingMethods.apply(this, arguments);
}

function _retrieveAvailableShippingMethods() {
  _retrieveAvailableShippingMethods = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            return _context14.abrupt("return", storage.getItem('availableShippingMethods'));

          case 1:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _retrieveAvailableShippingMethods.apply(this, arguments);
}

function saveAvailableShippingMethods(_x18) {
  return _saveAvailableShippingMethods.apply(this, arguments);
}

function _saveAvailableShippingMethods() {
  _saveAvailableShippingMethods = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(methods) {
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            return _context15.abrupt("return", storage.setItem('availableShippingMethods', methods));

          case 1:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _saveAvailableShippingMethods.apply(this, arguments);
}

function clearBillingAddress() {
  return _clearBillingAddress.apply(this, arguments);
}

function _clearBillingAddress() {
  _clearBillingAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            return _context16.abrupt("return", storage.removeItem('billing_address'));

          case 1:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
  return _clearBillingAddress.apply(this, arguments);
}

function retrieveBillingAddress() {
  return _retrieveBillingAddress.apply(this, arguments);
}

function _retrieveBillingAddress() {
  _retrieveBillingAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            return _context17.abrupt("return", storage.getItem('billing_address'));

          case 1:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));
  return _retrieveBillingAddress.apply(this, arguments);
}

function saveBillingAddress(_x19) {
  return _saveBillingAddress.apply(this, arguments);
}

function _saveBillingAddress() {
  _saveBillingAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(address) {
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            return _context18.abrupt("return", storage.setItem('billing_address', address));

          case 1:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));
  return _saveBillingAddress.apply(this, arguments);
}

function clearPaymentMethod() {
  return _clearPaymentMethod.apply(this, arguments);
}

function _clearPaymentMethod() {
  _clearPaymentMethod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            return _context19.abrupt("return", storage.removeItem('paymentMethod'));

          case 1:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));
  return _clearPaymentMethod.apply(this, arguments);
}

function retrievePaymentMethod() {
  return _retrievePaymentMethod.apply(this, arguments);
}

function _retrievePaymentMethod() {
  _retrievePaymentMethod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            return _context20.abrupt("return", storage.getItem('paymentMethod'));

          case 1:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));
  return _retrievePaymentMethod.apply(this, arguments);
}

function savePaymentMethod(_x20) {
  return _savePaymentMethod.apply(this, arguments);
}

function _savePaymentMethod() {
  _savePaymentMethod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(method) {
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            return _context21.abrupt("return", storage.setItem('paymentMethod', method));

          case 1:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));
  return _savePaymentMethod.apply(this, arguments);
}

function clearShippingAddress() {
  return _clearShippingAddress.apply(this, arguments);
}

function _clearShippingAddress() {
  _clearShippingAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            return _context22.abrupt("return", storage.removeItem('shipping_address'));

          case 1:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));
  return _clearShippingAddress.apply(this, arguments);
}

function retrieveShippingAddress() {
  return _retrieveShippingAddress.apply(this, arguments);
}

function _retrieveShippingAddress() {
  _retrieveShippingAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            return _context23.abrupt("return", storage.getItem('shipping_address'));

          case 1:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23);
  }));
  return _retrieveShippingAddress.apply(this, arguments);
}

function saveShippingAddress(_x21) {
  return _saveShippingAddress.apply(this, arguments);
}

function _saveShippingAddress() {
  _saveShippingAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(address) {
    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            return _context24.abrupt("return", storage.setItem('shipping_address', address));

          case 1:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24);
  }));
  return _saveShippingAddress.apply(this, arguments);
}

function clearShippingMethod() {
  return _clearShippingMethod.apply(this, arguments);
}

function _clearShippingMethod() {
  _clearShippingMethod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            return _context25.abrupt("return", storage.removeItem('shippingMethod'));

          case 1:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee25);
  }));
  return _clearShippingMethod.apply(this, arguments);
}

function retrieveShippingMethod() {
  return _retrieveShippingMethod.apply(this, arguments);
}

function _retrieveShippingMethod() {
  _retrieveShippingMethod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
    return _regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            return _context26.abrupt("return", storage.getItem('shippingMethod'));

          case 1:
          case "end":
            return _context26.stop();
        }
      }
    }, _callee26);
  }));
  return _retrieveShippingMethod.apply(this, arguments);
}

function saveShippingMethod(_x22) {
  return _saveShippingMethod.apply(this, arguments);
}

function _saveShippingMethod() {
  _saveShippingMethod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(method) {
    return _regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            return _context27.abrupt("return", storage.setItem('shippingMethod', method));

          case 1:
          case "end":
            return _context27.stop();
        }
      }
    }, _callee27);
  }));
  return _saveShippingMethod.apply(this, arguments);
}

export var clearCheckoutDataFromStorage = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return clearBillingAddress();

          case 2:
            _context12.next = 4;
            return clearPaymentMethod();

          case 4:
            _context12.next = 6;
            return clearShippingAddress();

          case 6:
            _context12.next = 8;
            return clearShippingMethod();

          case 8:
            _context12.next = 10;
            return clearAvailableShippingMethods();

          case 10:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));

  return function clearCheckoutDataFromStorage() {
    return _ref6.apply(this, arguments);
  };
}();